export default __webpack_public_path__ + "static/media/blue_circle.2e89b775.svg";